import { memo } from "react"
import { BzButton, BzHeading, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components"
import { Row, Col, Container } from "react-bootstrap"
import { handleModal } from "../../redux/actions/modals"
import { useDispatch, useSelector } from "react-redux";
import { getFundsReport, getMktAllowed, getPeridiocityWiseBalance, getproducteWiseBalance } from "../../redux/actions/funds";
import { getMarketAllowed } from "../../utils/global_functions";


const SuccessModal = ({ addFundOption,startDate, endDate}) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);

    const handleClose = () => {
        dispatch(handleModal([{ "SUCCESS_MODAL": false }]));
        dispatch(handleModal([{ "TRANSACTION_DETAILS_MODAL": false }]));
        // {    /* Hari K:22-02-2023 :BT-119138:Funds Viev- on success of funds transfer and withdrawal dispatching actions to show updated values -start*/ }
        dispatch(getproducteWiseBalance());
        dispatch(getPeridiocityWiseBalance());
        dispatch(getMktAllowed(getMarketAllowed(objLoginSession?.data?.exchanges)));
        dispatch(getFundsReport(startDate, endDate));
        // {    /* Hari K:22-02-2023 :BT-119138:Funds Viev- on success of funds transfer and withdrawal dispatching actions to show updated values -end*/ }

    };

    return (
        // SumitG-08-12-23
        <BzModal size='md' show={modals['SUCCESS_MODAL']} onHide={handleClose} centered>
            <BzModalHeader>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={10} className='d-flex justify-content-start align-items-center'>&nbsp;</Col>
                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                {addFundOption === "NEFT Tranfer" ?
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-4'>
                            <Col md={11} className='mrgauto text-center'>
                                <div className='icon-64 icon-done icon-positive mb-4'></div>
                                <BzHeading className='font-medium font-size6 color-text mb-3'>NEFT request sent successfully</BzHeading>
                                <div className='font-regular font-size3 color-text mb-4'>The details that have submitted will be verified by our team. On successful verification your account will be updated with the additional limit</div>
                                <div className='font-regular font-size2 color-subtext mb-4'>In case of any delay please contact out support team</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <BzButton className='btn btn-md btn-primary btn-block' onClick={handleClose}>OK</BzButton>
                            </Col>
                        </Row>
                    </Container>
                    :
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-4'>
                            <Col md={8} className='mrgauto text-center'>
                                <div className='icon-64 icon-done icon-positive mb-4'></div>
                                {modals['TRANSFER_MODAL'] === true ?
                                    <>
                                        <div className='font-regular font-size3 color-text mb-4'>Fund Transfer Request Submitted!</div>
                                    </> : modals['TRANSACTION_MODAL'] ?
                                        <>
                                            <div className='font-regular font-size3 color-text mb-4'>Withdraw request cancellation submitted successfully</div>
                                        </> :
                                        <>
                                            <BzHeading className='font-medium font-size6 color-text mb-3'>Request Submitted!</BzHeading>
                                            <div className='font-regular font-size3 color-text mb-4'>Funds will be deposited within 48 hours in the linked account</div>
                                        </>}
                            </Col>
                        </Row>
                    </Container>
                }
            </BzModalBody>
            <BzModalFooter className='bdr-none'>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col md={3} className='mrgauto text-center'>
                            <BzButton className='btn btn-md btn-primary btn-block text-uppercase' onClick={handleClose}>OK</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal >

    )
}

export default memo(SuccessModal)